import { getNozzleDirectionOptions, toNozzleDirectionText } from "@/common/filter"
import { Equipment } from "@/services/project/equipment/equipment.model"
import { Button, Input, Select, Space, Table } from "antd"
import { useMemo, useState } from "react"
import styles from "./index.module.less";
import classNames from "classnames"
import { NozzleDirection } from "@/types/common"

interface CustomNozzlesProps {
  value?: Equipment.CustomNozzle[]
  onChange?: (value: Equipment.CustomNozzle[]) => void
  disabled?: boolean
}

export const CustomNozzles = (props: CustomNozzlesProps) => {
  const { value = [], onChange, disabled } = props;
  const [record, setRecord] = useState<Equipment.CustomNozzle>();

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Simulator Code',
      dataIndex: 'simCode',
      key: 'simCode',
    },
    
    {
      title: 'Direction',
      dataIndex: 'direction',
      key: 'direction',
      render: (direction) => toNozzleDirectionText(direction)
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (val, current) => {
        return <Space><Button onClick={() => {
          const newVal = value.filter(item => item !== val)
          onChange?.(newVal)
        }}>Delete</Button></Space>
      }
    },
  ]

  const records = useMemo(() => {
    if (!value || value.length === 0) return null;
    return <Table
      bordered
      columns={columns}
      dataSource={value}
      className="table"
      rowKey='name'
      size="small"
      pagination={false}
    />
  }, [value, disabled])

  const setName = (name) => {
    if (!record) {
      setRecord({name} as any)
      return;
    }
    setRecord({...record, name})
  }


  const setDirection = (val: NozzleDirection) => {
    if (!record) {
      setRecord({direction: val} as any)
      return;
    }
    setRecord({...record, direction: val})
  }

  const setCode= (val: string) => {
    if (!record) {
      setRecord({simCode: val} as any)
      return;
    }
    setRecord({...record, simCode: val})
  }

  const addRecord = () => {
    if (!record) return;
    record.direction = record.direction || 0;
    onChange?.([...value, record]);
    setRecord({} as any)
  }

  return <div>
    {records}
    <Space align="baseline">
      <div className={classNames('flex-start', styles.pointEditor)}>
        <div>Name:</div>
        <Input className={classNames(styles.pointVal, styles.w200)} value={record?.name} onChange={(e) => setName(e.target.value)}/>
      </div>
      <div className={classNames('flex-start', styles.pointEditor)}>
        <div>Code:</div>
        <Input className={classNames(styles.pointVal, styles.w200)} value={record?.simCode} onChange={(e) => setCode(e.target.value)}/>
      </div>
    </Space>
    <Space align="baseline">
      <div className={classNames('flex-start', styles.pointEditor)}>
        <div>Direction:</div>
        <Select
          options={getNozzleDirectionOptions()}
          defaultValue={0}
          className={classNames(styles.pointVal, styles.w200)}
          onChange={val => setDirection(val)}
        />
      </div>
      <Button onClick={() => addRecord()}>Add</Button>
    </Space>
    
  </div>
}